module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_about03-273354d7f5f83864491e1e3cb9851616.png";